// @ts-nocheck
// Store Custom File
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const borderedTitle = (color?: string | null, thickness?: number | null, maxWidth?: number) => {
    const _color = color || "accent.main";
    const _thickness = thickness || 2;
    const _maxWidth = pxToRem(maxWidth || 0) || "100%";

    return css`
        display: inline-block;
        position: relative;
        padding-bottom: ${pxToRem(12)};

        &::after {
            position: absolute;
            content: "";
            left: 0;
            bottom: 0;
            height: ${pxToRem(_thickness)};
            width: 50%;
            min-width: ${pxToRem(75)};
            max-width: ${_maxWidth};
            background-color: ${getColor(_color)};
        }
    `;
};
